import { Injectable } from "@angular/core";
import { NgxPermissionsService } from "ngx-permissions";

@Injectable({
    providedIn: "root",
})
export class PermissionsHelperService {
    constructor(public readonly permissionsService: NgxPermissionsService) {}

    /**
     *
     * @description checks for multiple permissions attached to role; inclusive.
     * @param {string[]} permissionTypes
     * @param {string[]} actions
     */
    checkMultiplePermissions(permissionTypes: string[], actions: string[]) {
        permissionTypes.forEach(type => {
            const newType = type.replace(/\s/g, "");
            const newPermission = "manage" + newType;
            this.permissionsService.addPermission(newPermission, (permissionName, permissionsObject: ObjectConstructor) =>
                actions.every(action => !!permissionsObject[action + newType])
            );
        });
    }

    /**
     *
     * @description checks for singular permission attached to role.
     * @param {string[]} permissionTypes
     * @param {string} action
     */
    checkSingularPermission(permissionTypes: string[], action: string) {
        permissionTypes.forEach(type => {
            const newType = type.replace(/\s/g, "");
            const newPermission = "manage" + newType;
            this.permissionsService.addPermission(
                newPermission,
                (_, permissionsObject: ObjectConstructor) => !!permissionsObject[action + newType]
            );
        });
    }
}
